import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Modal from 'react-bootstrap/Modal';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import DatatableManagerFile from './datatables';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../../src/config/routes/guards/slug";

const ManagerFilesComp = (props) => {
  // console.log(props);
  const routeParams = useParams();

  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const [statusInNumber, setstatusInNumber] = useState(0);
  const [chapters, setChapters] = useState([]);
  const [standar, setStandar] = useState([]);
  const [element, setElement] = useState([]);
  const [idUser, setidUser] = useState('');
  const [role, setRole] = useState('');
  const [idBab, setidBab] = useState('');
  const [idStandar, setIdStandar] = useState('');
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);

  const fetchStandar = async () => {
    try {
      const options = {
        url: `/standards/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setStandar(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
      // return false;
      setidUser(data.data.id);
      // checkPicPokja(data.data.id)
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleChangeChapter = async (value) => {
    setidBab(value);
    // console.log(idBab);
    try {
      const options = {
        url: `/chapters/detailChapterListVariableParam/${value}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      setElement(data)
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleChangeStandar = async (value) => {
    setIdStandar(value)
    localStorage.removeItem('idStandar');
    localStorage.setItem('idStandar', value);
    try {
      const options = {
        url: `/chapters/getListByFk/${value}`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      setIsDropdownVisible(true)
      setChapters(data);
    } catch (err) {
      console.log(err.message);
    }
  }


  useEffect(() => {
    fetchStandar();
    fetchOneUser();
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="row col-12 mb-4">
            <div className="col-lg-4 col-11">
              <select
                className="form-select" onChange={(e) => handleChangeStandar(e.target.value)}
                value={idStandar}
              >
                <option value="">- Pilih Standar Akreditasi -</option>
                {standar.map((standar) => (
                  <option value={standar.id}>
                    {standar.Nama}
                  </option>
                ))}
              </select>
            </div>


            {isDropdownVisible &&
              <div className="col-lg-8 col-12">
                <select
                  className="form-select"
                  onChange={(e) => handleChangeChapter(e.target.value)}
                  value={idBab}
                >
                  <option value="">- Pilih Bab -</option>
                  {chapters.map((chapter) => (
                    <option value={chapter.id}>
                      {chapter.Deskripsi} ({chapter.Singkatan})
                    </option>
                  ))}
                </select>
              </div>}


            <div className="row col-12 mb-4">
              <DatatableManagerFile
                data={element} />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default ManagerFilesComp;
